import { FC, ReactNode } from 'react';

interface ChildrenProps {
  children: ReactNode;
}

const Footer: FC<ChildrenProps> = ({ children }) => {
  return <footer className="app-layout-footer fixed bottom-0 bg-white left-0 right-0 w-full p-2">{children}</footer>;
};

export default Footer;
